export type RobotBatteryFields = {
  batteryLevel: number | undefined;
  isCharging: boolean | undefined;
};

export const isBatteryLevel = (value: unknown): value is number =>
  typeof value === 'number' && Number.isInteger(value) && value >= 0 && value <= 100;

export const readBatteryFields = (source: Record<string, unknown>): RobotBatteryFields => ({
  batteryLevel: isBatteryLevel(source.batteryLevel) ? source.batteryLevel : undefined,
  isCharging: typeof source.isCharging === 'boolean' ? source.isCharging : undefined,
});
